import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    react: {
      useSuspense: false,
    },
    supportedLngs: ['en', 'uk', 'ru'],
    fallbackLng: 'en',
    detection: {
      order: ['localStorage', 'cookie', 'htmlTag', 'path', 'subdomain'],
      caches: ['localStorage']
    },
    backend: {
      // ?v= ламає кеш браузера при кожному релізі (версія бампається в package.json)
      loadPath: `/locales/{{lng}}.json?v=${process.env.REACT_APP_VERSION ?? ''}`,
    }
  });

export default i18n;
